export interface IOrderList {
  componentContent: ComponentContent
  componentTotal: ComponentTotal
  componetHeader: ComponetHeader
  infinityScroll: InfinityScroll
  overlayOrders: OverlayOrders
}

export interface OverlayOrders {
  page: string
  imageALL: string
  active: boolean
}

export interface InfinityScroll {
  cargaInicial: number
  segundaCarga: number
  spinner: ISpinner
}

export interface ISpinner {
  name: string
  color: string
}

export interface ButtomAdd {
  color: string
  size: string
  state: boolean
  state1: string
  state2: string
  text: string
}

export interface Descriptions {
  priceColor: string
  subtitleColor: string
  titleColor: string
  sku: SKU
}

export interface SKU {
  visible: boolean
  color: string
  fontSize: string
  text: string
}

export interface IconAdd {
  color: string
  mode: string
  name: string
  size: string
}

export interface IconRemove {
  color: string
  mode: string
  name: string
  size: string
}

export interface Buttoms {
  end: number
  iconAdd: IconAdd
  iconRemove: IconRemove
  initial: number
  mode: string
  size: string
}

export interface Range {
  buttoms: Buttoms
}

export interface ComponentContent {
  buttomAdd: ButtomAdd
  descriptions: Descriptions
  range: Range
  noData: NoData
}

export interface NoData {
  text: string
  fontSize: string
  color: string
}

export interface ButtomPrice {
  color: string
  expand: string
  text: string
}

export interface Icon {
  color: string
  name: string
}

export interface ButtomCart {
  fill: string
  icon: Icon
}

export interface ComponentTotal {
  buttomCart: ButtomCart
  buttomPrice: ButtomPrice
  notCart: string
  totalProductsPart1: string
  totalProductsPart2: string
}

export interface ButtomHistory {
  color: string
  icon: string
}

export interface Search {
  debounce: number
  placeholder: string
  color: string
}

export interface ComponetHeader {
  buttomHistory: ButtomHistory
  search: Search
}

export const DefaultListOrder = {
  componentContent: {
    buttomAdd: {
      color: 'ButtomBlue',
      size: 'small',
      state: true,
      state1: 'Agregar',
      state2: 'Actualizar',
      text: 'Agregar'
    },
    descriptions: {
      priceColor: '#009bdd',
      subtitleColor: '#9b9fa8',
      titleColor: '#4d5868',
      sku: {
        visible: false,
        color: '#9b9fa8',
        fontSize: '10px',
        text: 'Sabores:'
      }
    },
    range: {
      buttoms: {
        end: 20,
        iconAdd: {
          color: 'primary',
          mode: 'ios',
          name: 'add',
          size: 'small'
        },
        iconRemove: {
          color: '',
          mode: 'ios',
          name: 'remove',
          size: 'small'
        },
        initial: 0,
        mode: 'ios',
        size: 'small'
      }
    },
    noData: {
      text: 'No se encontraron resultados',
      fontSize: '15px',
      color: '#4d5868'
    }
  },
  componentTotal: {
    buttomCart: {
      fill: 'clear',
      icon: {
        color: 'light',
        name: 'iconos/empty-cart.svg'
      }
    },
    buttomPrice: {
      color: 'ButtomBlue',
      expand: 'block',
      text: 'Comprar'
    },
    notCart: 'Aún no tienes productos agregados',
    totalProductsPart1: '',
    totalProductsPart2: ' producto(s)'
  },
  componetHeader: {
    buttomHistory: {
      color: 'light',
      icon: './assets/icon/history-orders.svg'
    },
    search: {
      debounce: 500,
      placeholder: 'Buscar producto',
      color: 'light'
    }
  },
  infinityScroll: {
    cargaInicial: 20,
    segundaCarga: 10,
    spinner: {
      name: 'lines',
      color: 'primary'
    }
  },
  overlayOrders: {
    active: true,
    imageALL: 'Images/overlayOrders.png',
    page: 'PRODUCTOS'
  },
  modalExitCP: {
    text: '¡Espera!',
    subText: 'Aún no has enviado esta solicitud ¿Seguro deseas salir?',
    textFooter: 'Perderás cualquier avance que hayas realizado',
    buttomLeft: {
      class: 'ion-text-capitalize',
      text: 'Salir'
    },
    buttomRight: {
      class: 'ion-text-capitalize',
      text: 'Cancelar'
    },
    backdropDismiss: true
  },
  modalProblemSendCP: {
    text: '¡Oh no!',
    subText: 'Estamos teniendo problemas para enviar tu solicitud.<br> Por favor inténtalo más tarde',
    textFooter: 'Si el problema persiste, ponte en contacto',
    buttomRight: {
      class: 'ion-text-capitalize',
      text: 'Salir'
    },
    backdropDismiss: true
  },
  modalRetrySendCP: {
    text: '¡Enviando solicitud!',
    subText: 'No pudimos enviar tu solicitud ¿Deseas intentarlo nuevamente?',
    textFooter: 'Si el problema persiste, ponte en contacto',
    buttomLeft: {
      class: 'ion-text-capitalize',
      text: 'Salir'
    },
    buttomRight: {
      class: 'ion-text-capitalize',
      text: 'Reintentar'
    },
    backdropDismiss: true
  },
  modalProductDeleteCP: {
    text: '¡Espera!',
    subText: '¿Seguro deseas eliminar <ion-text color="tpcta">{{descripcion_cp}}</ion-text> de tu solicitud?',
    buttomLeft: {
      class: 'ion-text-capitalize',
      text: 'Eliminar'
    },
    buttomRight: {
      class: 'ion-text-capitalize',
      text: 'Cancelar'
    },
    backdropDismiss: true
  },
  modalDeleteSendCP: {
    text: '¡Hey espera!',
    subText: '¿Seguro deseas eliminar esta solicitud?',
    textFooter: 'Esta acción no podrá ser revertida',
    buttomLeft: {
      class: 'ion-text-capitalize',
      text: 'Eliminar'
    },
    buttomRight: {
      class: 'ion-text-capitalize',
      text: 'Cancelar'
    },
    backdropDismiss: true
  }
}
